import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { ButtonPrimary } from './layout/StyledComponents';

const PatientFormsStyled = styled.div`
    h2 {
        color: ${theme.colors.gray5};
    }
    button {
        border-radius: 10px;
        font-weight: 500;
        padding: 32px 0;
    }
    a {
        font-weight: 500;
        text-decoration: none;
    }
    p {
        margin-bottom: 32px;
    }
    @media ${theme.device.tablet} {
        p {
            margin-bottom: 64px;
        }
    }
`;

const OnlineForm = styled.div`
    button {
        width: 100%;
    }
    margin-bottom: 54px;
`;

const PrintableForms = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;

    justify-content: space-between;
    button {
        margin-bottom: 24px;
        min-width: 380px;
        flex-shrink: 0;
    }
    @media ${theme.device.mobileL} {
        button {
            min-width: 380px;
        }
    }
    @media ${theme.device.tablet} {
        button {
            min-width: 350px;
        }
    }
    @media ${theme.device.laptop} {
        button {
            min-width: 480px;
        }
    }
    @media ${theme.device.laptopL} {
        button {
            min-width: 523px;
        }
    }
`;

export const PatientForms: React.FC = () => {
    return (
        <PatientFormsStyled>
            <p>
                If you would like to save some time during your first visit with Dr. Rigsby, Dr.
                Kizirian and Dr. Sharpstein, we are happy to provide our new patient forms to you.
                Our team works hard to provide you with the comfortable, streamlined dental
                experience you deserve when you visit us at First Care Dental Assoc. If you would
                like assistance or are interested in the care our friendly dentists in Tallahassee,
                Florida, can provide for you, please feel free to contact us today.
            </p>
            <OnlineForm>
                <h2>Online Forms</h2>
                <a
                    href="https://forms.mydentistlink.com/d16008d1-348d-4342-8522-a9732fb3317e"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary color="green">Fill Out Patient Form</ButtonPrimary>
                </a>
            </OnlineForm>
            <h2>Printable Forms</h2>
            <PrintableForms>
                <a
                    href="https://www.firstcaredental.org/wp-content/uploads/2015/06/acknowledgement-privacy-practices.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary color="green">Acknowledgement Privacy Practices</ButtonPrimary>
                </a>
                <a
                    href="https://www.firstcaredental.org/wp-content/uploads/2015/06/financial-agreement.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary color="green">Financial Agreement</ButtonPrimary>
                </a>
                <a
                    href="https://www.firstcaredental.org/wp-content/uploads/2019/03/new_privacy_practices.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary color="green">Privacy Practices</ButtonPrimary>
                </a>
                <a
                    href="https://www.firstcaredental.org/wp-content/uploads/2015/06/registration-form.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ButtonPrimary color="green">Registration Form</ButtonPrimary>
                </a>
            </PrintableForms>
        </PatientFormsStyled>
    );
};
